module.exports = __webpack_public_path__ + "media/bootstrap-icons/search-4b174aba.svg";